function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M106.766 60.04h-.734v6.91h.734v-6.91zM106.553 32.185c-.733-9.73-2.347-10-11.374-11.524l-2.317-.396c-5.338-.93-7.106-4.865-8.968-9.034-2.076-4.615-4.217-9.385-11.609-10.36-3.725-.49-6.812.287-9.195 2.301-4.862 4.11-5.2 12.096-5.207 12.177h-.733c0-.337.344-8.382 5.456-12.704C65.15.49 68.472-.345 72.373.175c7.78.997 10.127 6.184 12.18 10.756 1.79 3.986 3.477 7.751 8.426 8.616l2.318.396c9.056 1.523 11.256 1.883 11.989 12.183l-.733.06zM12.27 36.764c-.314-.535-7.01-13.876-2.712-22.09 1.723-3.296 4.993-5.289 9.723-5.926 3.572-.476 6.952-1.063 10.223-1.634 10.083-1.744 18.04-3.128 22.468.293 2.09 1.612 3.256 4.198 3.557 7.898l-.733.059c-.286-3.488-1.357-5.862-3.271-7.378-4.173-3.224-11.997-1.868-21.897-.147-3.278.564-6.666 1.158-10.266 1.634-4.473.608-7.546 2.47-9.152 5.51-4.128 7.875 2.647 21.283 2.713 21.415l-.652.366z",
  fill: "#CCC0FD"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M79.611 79.668h.733v-64.7H29.38v64.7h.734",
  stroke: "#2B2B23",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M70.958 17.7H32.555v4.338h38.403v-4.337z",
  fill: "#CCC0FD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M77.198 21.387l-2.758-2.755.165-.165 2.757 2.755-.164.165z",
  stroke: "#2B2B23",
  strokeWidth: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M74.591 21.371l-.164-.165 2.757-2.755.165.165-2.758 2.755zM32.805 27.356v-.233H53.79v.233H32.805zM32.805 29.818v-.233H53.79v.233H32.805zM32.805 32.272v-.233H53.79v.233H32.805zM32.805 34.734V34.5H53.79v.233H32.805z",
  stroke: "#2B2B23",
  strokeWidth: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M77.477 27.24h-19.96v8.096h19.96V27.24zM77.477 39.827H32.54v8.095h44.937v-8.095zM40.643 58.48H32.54v8.096h8.103V58.48zM52.918 58.48h-8.103v8.096h8.103V58.48zM65.194 58.48h-8.103v8.096h8.103V58.48zM77.47 58.48h-8.103v8.096h8.103V58.48z",
  fill: "#CCC0FD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M78.555 68.033s8.184 5.297 8.184 17.584c0 12.286-1.217 17.085-7.099 20.214h-47.1c-8.235 0-7.245-13.503-7.099-22.148.147-8.645 8.272-13.825 8.272-13.825",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M33.57 70.095c-.569.397-2.219 1.625-3.87 3.556-2.015 2.353-4.05 5.772-4.105 10.021h0v.004c0 .653 0 1.311-.044 1.998h0v.01l-.001.039c-.077 3.284-.163 6.997.18 10.314.342 3.317 1.118 6.305 2.825 8.063a5.305 5.305 0 004.004 1.607h47.057l.055-.03c2.947-1.586 4.697-3.618 5.7-6.764.994-3.122 1.252-7.338 1.252-13.289 0-6.012-2.005-10.367-4.024-13.228a19.962 19.962 0 00-2.786-3.188 15.005 15.005 0 00-1.116-.93l.125-.192.164.123c.229.175.553.437.941.79a20.028 20.028 0 012.832 3.212c2.052 2.886 4.097 7.297 4.097 13.413 0 5.863-.255 10.124-1.279 13.33-1.017 3.184-2.796 5.331-5.877 6.963l-.01.005-.007.005-.02.013H32.54v0h-.008a5.571 5.571 0 01-4.154-1.676h0c-1.701-1.738-2.528-4.666-2.898-8.053-.369-3.376-.28-7.148-.2-10.53h0v-.005c0-.422.013-.795.024-1.162.009-.279.018-.553.02-.842.077-4.294 2.127-7.758 4.186-10.165a22.82 22.82 0 012.83-2.773 18.795 18.795 0 011.102-.84l.128.2z",
  stroke: "#2B2B23",
  strokeWidth: 0.5
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M32.547 85.624v20.932h47.1V85.624",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M79.531 106.19V85.874h.233v20.798H32.431V85.874h.233v20.566H79.53v-.25z",
  stroke: "#2B2B23",
  strokeWidth: 0.5
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M37.98 57.74s-5.492 1.582-7.398 7.158c-1.907 5.575 10.706 8.3 25.864 8.3 15.157 0 24.808-4.058 23.341-9.004-1.467-4.945-3.755-6.454-3.755-6.454",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M30.917 67.88h0l-.004-.004a3.148 3.148 0 01-.441-2.98h0l.002-.006c1.682-4.958 6.136-6.775 7.234-7.155l.07.25-.026.009a9.734 9.734 0 00-.655.26c-.544.24-1.282.614-2.075 1.157-1.586 1.086-3.403 2.855-4.324 5.579a2.915 2.915 0 00.41 2.79c.62.845 1.704 1.591 3.157 2.238 1.457.649 3.31 1.208 5.493 1.665 4.368.915 10.088 1.429 16.688 1.429 5.515 0 10.486-.56 14.411-1.556 3.907-.99 6.83-2.425 8.188-4.217a3.356 3.356 0 00.63-3.083v-.001c-1.19-3.997-2.923-5.738-3.505-6.232l.128-.193c.596.494 2.373 2.242 3.601 6.361a3.557 3.557 0 01-.685 3.272h0l-.009.01c-1.307 1.754-4.117 3.229-8.076 4.262-3.945 1.03-8.982 1.61-14.683 1.61-6.795 0-12.584-.52-16.98-1.471-2.198-.476-4.04-1.058-5.485-1.733-1.447-.677-2.474-1.438-3.064-2.26z",
  stroke: "#2B2B23",
  strokeWidth: 0.5
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M53.505 31.1s-5.932-4.805-9.533-.578a8.884 8.884 0 00-1.833 8.638s-4.4.168-4.884 2.66a7.702 7.702 0 00.865 4.769 7.204 7.204 0 00-3.123 7.473c1.026 4.96 13.86 8.22 13.86 8.22s5.132-2.337 10.486-4.88c5.353-2.541-5.838-26.301-5.838-26.301z",
  fill: "#F2F2ED"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M44.91 36.23c.287 1.01 7.43 4.644 11.954 4.205 0 0-3.33 4.059.183 8.982 0 0-3.886 3.861-2.852 8.645.418 1.927 7.824 9.437 11.49 7.803 3.667-1.634 7.737-1.766 9.717-6.403 1.98-4.638 2.31-11.027.073-14.331-2.236-3.304-9.166-5.788-9.965-8.572 0 0 .96-2.447-2.64-4.762-6.402-4.125-7.487-.418-7.487-.418-2.787-1.509-11.843.03-10.472 4.85z",
  fill: "#F2F2ED"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M54.965 59.462c2.065 2.823 7.68 7.758 10.72 6.403.877-.39 1.777-.696 2.666-.997 2.828-.958 5.544-1.878 7.051-5.406 1.98-4.638 2.31-11.027.073-14.331-1.06-1.568-3.178-2.95-5.197-4.269-2.235-1.46-4.348-2.84-4.768-4.303 0 0 .96-2.447-2.64-4.762-6.402-4.125-7.487-.418-7.487-.418-.543-.294-1.323-.472-2.218-.533-1.31-.936-6.108-3.946-9.193-.324a8.884 8.884 0 00-1.833 8.638s-4.4.168-4.884 2.66a7.702 7.702 0 00.865 4.769 7.204 7.204 0 00-3.123 7.473c1.026 4.96 13.86 8.22 13.86 8.22s2.64-1.202 6.108-2.82z",
  stroke: "#2B2B23",
  strokeWidth: 0.75
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M24.085 36.596v-.25H1.117v28.377h22.968V36.596zM117.883 32.156v-.25H94.915v28.377h22.968V32.156zM117.883 66.95v-.25H94.915v28.376h22.968V66.95z",
  fill: "#fff",
  stroke: "#2F2256",
  strokeWidth: 0.5
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M22.295 38.317H3.09v4.338h19.205v-4.338zM116.005 34.288H96.8v9.583h19.205v-9.583zM116.005 69.088H96.8v2.697h19.205v-2.697zM116.005 83.47H96.8v9.012h19.205V83.47z",
  fill: "#CCC0FD"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M97.05 47.445v-.232h18.705v.232H97.05zM97.05 49.9v-.233h18.705v.233H97.05zM97.05 52.361v-.232h18.705v.232H97.05zM97.05 54.823v-.233h18.705v.233H97.05zM97.05 73.886v-.232h18.705v.232H97.05zM97.05 76.34v-.232h18.705v.233H97.05zM97.05 78.802v-.232h18.705v.233H97.05zM97.05 81.257v-.233h18.705v.233H97.05z",
  stroke: "#2B2B23",
  strokeWidth: 0.5
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M77.022 102.695l-42.187 1.355V81.61s-5.016 2.857-5.09 6.366c-.073 3.51-3.072-2.93-2.324-5.692.748-2.763 5.133-10.023 9.167-8.521 4.033 1.502 31.65 4.234 36.827 1.626s10.17-1.253 10.17 3.927v10.887s-.733-8.498-3.607-8.594c-2.875-.095-4.554 7.092-4.092 9.48.462 2.39 1.136 11.606 1.136 11.606z",
  fill: "#fff"
});

function SvgResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 119 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

export default __webpack_public_path__ + "static/results.fa6ac226.svg";
export { SvgResults as ReactComponent };